// extracted by mini-css-extract-plugin
module.exports = {"partnerListItemWrapper":"J3KCs","partnerListItem":"lVE2l","partnerListItemDescription":"y9G5T","descriptionTextWrapper":"_4batZ","partnerMaskWrapper":"E8rvE"};